import axios from "axios";
import { User_Service_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const saveResendLinkEmployeeActions = {
  SAVE_RESEND_LINK_EMPLOYEE_SUCCESS: "SAVE_RESEND_LINK_EMPLOYEE_SUCCESS",
  SAVE_RESEND_LINK_EMPLOYEE_ERROR: "SAVE_RESEND_LINK_EMPLOYEE_ERROR",
};

export function saveResendLinkEmployeeDetails(props) {
  const { access_token, values, userId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/resendWelcomeMail?userId=${userId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveResendLinkEmployeeSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveResendLinkEmployeeError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveResendLinkEmployeeError(err));
          return err.response;
        }
      });
}

export function saveResendLinkEmployeeError(error) {
  return {
    type: saveResendLinkEmployeeActions.SAVE_RESEND_LINK_EMPLOYEE_ERROR,
    payload: error,
  };
}

export function saveResendLinkEmployeeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveResendLinkEmployeeActions.SAVE_RESEND_LINK_EMPLOYEE_SUCCESS,
      payload: props,
    });
  };
}
